export { default as MenuObjectSkeleton } from './menu-object.skeleton';
